<template>
  <div class="weekday-selector">
    <div v-if="editMode" :class="[ inline ? '' : 'weekday-selector-popup' ]">
      <el-checkbox-group
        style="display: inline-block; margin: 0 0.5em;"
        :size="size"
        v-bind:value="commitmentWeekdaysArray"
        v-on:input="onInput"
        @change="onUpdateWeekdays">
        <el-checkbox-button v-for="day in weekdays" :label="day" :key="'weekday-'+day">{{day}}</el-checkbox-button>
      </el-checkbox-group>
      <el-button-group style="top: 3px; position: relative">
        <el-button size="mini" type="success" @click="onSave">
          <i class="el-icon-check"></i>
          <!-- ok -->
        </el-button>
        <el-button size="mini" type="info" @click="onCancel">
          <i class="el-icon-close"></i>
          <!-- cancel -->
        </el-button>
      </el-button-group>
      <div class="weekday-selector-helper">
        <a href="" @click.prevent="commitmentWeekdaysArray = weekdays; onUpdateWeekdays()">all</a>,
        <a href="" @click.prevent="commitmentWeekdaysArray = []; onUpdateWeekdays()">none</a>,
        <a href="" @click.prevent="commitmentWeekdaysArray = weekdays.slice(0,5); onUpdateWeekdays()">weekdays</a>,
        <a href="" @click.prevent="commitmentWeekdaysArray = weekdays.slice(-2); onUpdateWeekdays()">weekend</a>
      </div>
    </div>
    <template v-if="!editMode || !inline">
      <a href="#" @click.prevent="editMode = !editMode">
        {{humanizedWeekdayList}}
      </a>
    </template>
  </div>
</template>

<script>
const weekdays_en = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
// const weekdays_de = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

export default {
  props: {
    inline: {
      default: true /* inline false geht aktuell nicht, wegen layout */
    },
    value: {
      default: []
    },
    size: {
      default: 'medium'
    },
    humanize: {
      default: false
    }
  },
  data: () => ({
    editMode: false,
    emitArray: false,
    commitmentWeekdaysArray: [],
    weekdays: weekdays_en
  }),
  mounted() {
    if ( Array.isArray(this.value) ) {
      this.emitArray = true;
      this.commitmentWeekdaysArray = this.value;
    } else {
      this.emitArray = false;
      this.parseInput(this.value);
    }
  },
  computed: {
    humanizedWeekdayList() {
      if ( this.humanize ) {
        let pattern = this.generatePatternStr();
        if ( pattern === 'xxxxx--' ) {
          return 'every weekday';
        }
        if ( pattern === '-----xx' ) {
          return 'every day on weekends';
        }
        if ( pattern === '-------' ) {
          return 'never';
        }
        if ( pattern === 'xxxxxxx' ) {
          return 'every day';
        }
        return 'every ' + this.commitmentWeekdaysArraySorted.join(', ');
      }
      return this.commitmentWeekdaysArray.length === 0
              ? 'never'
              : this.commitmentWeekdaysArraySorted.join(', ');
    },
    commitmentWeekdaysArraySorted() {
      /* move to util? */
      const mapWeekdayToIndex = {};
      this.weekdays.forEach((element, index) => {
          mapWeekdayToIndex[element] = index;
      });
      const sortByDaySorter = (a, b) => {
        return mapWeekdayToIndex[a] - mapWeekdayToIndex[b];
      };
      return this.commitmentWeekdaysArray.slice().sort(sortByDaySorter);
    }
  },
  methods: {
    parseInput(weekdays) {
      this.commitmentWeekdaysArray = [];
      for ( let i = 0; i < 7; i++) {
        if ( weekdays[i] === 'x' ) {
          this.commitmentWeekdaysArray.push( this.weekdays[i] )
        }
      }
    },

    generatePatternStr() {
      let str = '';
      for ( let i = 0; i < this.weekdays.length; i++) {
        str += ( this.commitmentWeekdaysArray.includes( this.weekdays[i] ) ) ? 'x' : '-';
      }
      return str;
    },

    onUpdateWeekdays() {
      if ( this.emitArray ) {
        this.$emit('input', this.commitmentWeekdaysArray)
      } else {
        this.$emit('input', this.generatePatternStr())
      }
    },

    onInput($event) {
      this.commitmentWeekdaysArray = $event;
    },

    onSave() {
      this.editMode = false;
      if ( this.emitArray ) {
        this.$emit('save', this.commitmentWeekdaysArray)
      } else {
        this.$emit('save', this.generatePatternStr())
      }
    },

    onCancel() {
      this.$emit('cancel');
      this.editMode = false;
    }
  }
}
</script>

<style>
/* optional */
.weekday-selector-popup {
  border: 1px solid #b7b3b3;
  position: absolute;
  width: 400px;
  background: white;
  z-index: 9999;
  text-align: center;
  border-radius: 5px;
  box-shadow: 2px 2px 10px #b3b3b3;
  padding-top: 10px;
  line-height: 1.2em;
  margin-left: 6px;
  margin-top: 8px;
  padding-bottom: 10px;
}
.weekday-selector {
  position: relative;
}
.weekday-selector .el-checkbox-button {
  margin-bottom: 0;
}
.weekday-selector-helper {
  font-size: 9pt;
}
</style>
